import { License } from '@pixacare/domain';

export type LicensesState = {
  licenses: {
    [licenseId: number]: License;
  };
};

export const initialLicensesState: LicensesState = {
  licenses: {},
};
